export default "__VITE_ASSET__57d82c27__"